import { useEffect } from 'react';

export function useMobxSync<T extends object>(
  props: Partial<T>,
  store: T
): void {
  useEffect(() => {
    for (const key in props) {
      if (props.hasOwnProperty(key)) {
        const prop = props[key];
        if (prop) {
          store[key] = props[key] as T[Extract<keyof T, string>];
        }
      }
    }
  }, [props, store]);
}
